<template>
    <BasePromotionCard title="Make this a goal" description="Track this as an explicit goal so we can revisit progress over time." cta-label="Create goal" cta-href="/journeys/">
        <template #icon>
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4M4 19h4M13 3l4 4-2 6h6l-7 8 2-6H7l6-12z" />
            </svg>
        </template>
        <template #draft>
            <div class="flex items-center gap-2">
                <span :class="typeBadgeClass" class="rounded-full px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide">{{ data.goal_type }}</span>
                <span class="font-medium text-slate-900">{{ data.suggested_title }}</span>
            </div>
            <p v-if="data.suggested_description" class="mt-1 text-slate-600">{{ data.suggested_description }}</p>
        </template>
    </BasePromotionCard>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { PromoteGoalCreationResult } from "../../types";
import BasePromotionCard from "./BasePromotionCard.vue";

const props = defineProps<{ result: PromoteGoalCreationResult; toolName: string }>();

const data = computed<PromoteGoalCreationResult>(() => props.result);

const typeBadgeClass = computed(() => (data.value.goal_type === "performance" ? "bg-amber-100 text-amber-800" : "bg-indigo-100 text-indigo-800"));
</script>
